module.exports = __webpack_public_path__ + "img/arrow-right.660c9a3f.svg";